import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 10px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};
  padding-bottom: 40px;
  color: ${({ theme }) => theme.colors.neutral.white};

  grid-area: ${({ gridArea }) => gridArea};
`;

export const Commitments = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;

  width: 100%;
`;

export const Commitment = styled.img`
  width: 110px;
  height: 110px;
  cursor: pointer;

  border: ${({ theme, selected }) =>
    selected ? `2px solid ${theme.colors.primary.blue}` : "none"};

  transition: border 0.03s;

  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
    `}
`;
